module.exports = __webpack_public_path__ + "img/pesonal_question_answered_white.908813ca.svg";